export const data = {
  projects: [
    {
      title: "AI SaaS Platform",
      description:
        "Integrates OpenAI and Replicate AI tools for diverse tasks: image, video, conversation, music, and code generation. Provides five free trials; charges monthly fees via Stripe Checkout afterwards.",
      technologies: ["Next.js", "Tailwind", "Stripe", "Shadcn/ui", "Prisma"],
      github: "https://github.com/Yash-Sajwan24/ai-sass",
      website: "https://ai-sass-yash.vercel.app/",
      img: "https://incubator.ucf.edu/wp-content/uploads/2023/07/artificial-intelligence-new-technology-science-futuristic-abstract-human-brain-ai-technology-cpu-central-processor-unit-chipset-big-data-machine-learning-cyber-mind-domination-generative-ai-scaled-1.jpg",
      yt: "https://youtu.be/HX6boY6LCmI",
    },
    {
      title: "SummaBriefs",
      description:
        "An open-source article summarizer that streamlines content creation & curation. Transform lengthy articles into concise summaries effortlessly, allowing you to grasp key points without spending hours reading.",
      technologies: ["React", "Tailwind CSS", "Rapid Api", "Redux Toolkit"],
      github: "https://github.com/Yash-Sajwan24/SummaBriefs",
      website: "https://summabriefs.netlify.app/",
      img: "https://www.twinglar.com/posts/902d7f00-b1ed-4ca3-8fce-bae95c527572.png",
      yt: "https://www.youtube.com/watch?v=xerCwrJMf90",
    },
    {
      title: "To-Do-List",
      description:
        "This application provides an efficient and user-friendly platform to manage your tasks and stay organized. Whether an individual or a professional, this project empowers you to keep track of your assignments effortlessly.",
      technologies: ["Node.Js", "Express.Js", "MongoDB", "EJS", "CSS"],
      github: "https://github.com/Yash-Sajwan24/to-do-list",
      website: "https://to-do-list24.onrender.com/",
      img: "https://images.ctfassets.net/lzny33ho1g45/1GtQ57fpTQvFvhixeyIVim/03e81fa6569517e64a1e2aa030987d8a/doodled_to-do_list",
      yt: "https://www.youtube.com/watch?v=mznzv-MpA1Q",
    },
    
  ],
};
